import { createContext, useContext, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Home from "@/pages/Home";
import LegalPage from "@/pages/Legal";
import Panel from "@/pages/Panel";
import Visita from "@/pages/Visita";
import CookieBanner from "@/components/CookieBanner";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext({ user: undefined, setUser: () => {}, logout: async () => {} });
export const useAuth = () => useContext(AuthContext);

function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      /* sesión ya cerrada */
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aviso-legal" element={<LegalPage page="aviso-legal" />} />
          <Route path="/privacidad" element={<LegalPage page="privacidad" />} />
          <Route path="/cookies" element={<LegalPage page="cookies" />} />
          <Route path="/panel" element={<Panel />} />
          <Route path="/visita" element={<Visita />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <CookieBanner />
        <WhatsAppFloat />
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
